'use client';

import * as React from 'react';

/**
 * @ignore - internal component.
 */
const GridLegacyContext = /*#__PURE__*/React.createContext();
if (process.env.NODE_ENV !== 'production') {
  GridLegacyContext.displayName = 'GridLegacyContext';
}
export default GridLegacyContext;